import { CARD_VARIANT } from "./elements.js";

export const PLACEHOLDER_ROW_COUNT = 3;

export const getBettoGridColumnCount = (width, cardVariant = CARD_VARIANT.GRID) => {
	if (cardVariant === CARD_VARIANT.SLIDER) {
		if (width >= 1440) return 8;
		if (width >= 1024) return 7;
		if (width >= 768) return 5;
		return 3;
	}

	if (width >= 1100) return 7;
	if (width >= 900) return 5;
	if (width >= 640) return 4;
	return 3;
};

export const getBettoPlaceholderCount = (width, cardVariant = CARD_VARIANT.GRID) =>
	getBettoGridColumnCount(width, cardVariant) * PLACEHOLDER_ROW_COUNT;
